import { Typography } from "@material-ui/core";
import * as React from "react";

const ErrorMessage = (props: { errorMessage: string }) => (
  <Typography className="error-message" variant="subtitle1">
    {props.errorMessage}
  </Typography>
);

export default ErrorMessage;
